import { Injectable } from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ToastDetailedErrorModel} from '../models/toasts/toast-detailed-error.model';
import {ErrorDetails, ErrorInfos, MicroserviceError} from './error-infos';
import {NotificationToastService} from '../services/notifications/notification-toast.service';


@Injectable({
  providedIn: 'root'
})
export class NetcoreErrorInterceptorService implements HttpInterceptor{

  constructor(private notificationToastService: NotificationToastService) { }

  private static isBadRequest(err: HttpErrorResponse): boolean {
    const e = err.error;
    const result = err.status === 400 && e != null && e['microservice'] != null && !e['isDomainError'];
    return result;
  }
  private isNetcoreError(err: HttpErrorResponse): boolean {
    return err.error && err.error['microservice'] != null && err.status == 500
  }

  private extractInfos(err: HttpErrorResponse) {
    return new Observable<any>(observer => {
      if (this.isNetcoreError(err)) {
        const msg = err.error as ErrorDetails;
        console.error(msg.message);
        console.error(msg.stacktrace);
        observer.error(new MicroserviceError('Oups ! Quelque chose s’est mal passé...', `
        <b>Détails techniques :</b><hr>
        <b>Message : </b> ${msg.message}<br>
        <b>Timestamp : </b> ${msg.timestamp}<br>
        <b>Microservice :</b> ${msg.microservice}<br>
        <b>Url :</b> ${err.url}`, msg));
      }
      else if (NetcoreErrorInterceptorService.isBadRequest(err)) {
        let message = err.error.message;
        if (message) {
          const actionController = err.url.match(/\/api.*/g)
          message = `${actionController} : ${message}`
        }
        const detail = Object.assign({}, err.error, {message});
        const msg = err.error as ErrorDetails;
        observer.error(new MicroserviceError(`Oups ! Quelque chose s’est mal passé...`, `
        <b>Détails techniques : </b><hr>
        <b>Message :</b> Erreur 400 : ${msg.message}<br>
        <b>Timestamp : </b>${msg.timestamp}<br>
        <b>Microservice :</b> ${msg.microservice}<br>
        <b>Url : </b>${err.url}`, detail))
      } else {
        observer.error(null)
      }
    })
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((erreurBrute: HttpErrorResponse) => {
        return this.extractInfos(erreurBrute).pipe(
          catchError((erreurDecodee: ErrorInfos) => {
            if (erreurDecodee != null) {
              this.notificationToastService.push(new ToastDetailedErrorModel(erreurDecodee.content, erreurDecodee.title, erreurDecodee as MicroserviceError));
            }
            return throwError(erreurBrute);
          }),
        ) }
      ),
    );
  }
}
